import Content from "Types/Content";
import "./assets/style.scss";
import Ventanita from "./components/Ventanita";
import Hang from "./assets/Hang.png";
import set1A from "./assets/set1A.png";
import set1B from "./assets/set1B.png";
import set2 from "./assets/set2.png";
import set3 from "./assets/set3.png";
import set4 from "./assets/set4.png";
import set5 from "./assets/set5.png";
import set6 from "./assets/set6.png";
import rufoLost from "./assets/RufoLost.png";
import rufoWins from "./assets/RufoWins.png";
import rufoWelcome from "./assets/RufoWelcome.png";
import useAhoracado from "./useAhorcado";
import reIcon from "./assets/refresh.png";
import { Fragment } from "react";

const imgHangman = [Hang, set1A, set2, set3, set4, set5, set6];

const Ahorcado = () => {
  const {
    reStart,
    handleClickLetter,
    keyBoard,
    rightLettersWritten,
    rightLetters,
    wrongLetters,
    currentBand
  } = useAhoracado();

  return (
    <div className='container p-5 bg-dark '>
      <Ventanita
        title='Bienvenido a mi juego'
        body={<img className='img-fluid' src={rufoWelcome} alt='' />}
        buttonText='Genial!'
      />
      {wrongLetters.length >= 6 && (
        <Ventanita
          title='Perdiste'
          body={<img className='img-fluid' src={rufoLost} alt='' />}
          buttonText='Seguí participando'
          onClose={reStart}
        />
      )}

      {rightLettersWritten.length === rightLetters.length && (
        <Fragment>
          <Ventanita
            title='Ganaste!!'
            body={<img className='img-fluid' src={rufoWins} alt='' />}
            buttonText='Jugar otra vez'
            onClose={reStart}
          />
        </Fragment>
      )}

      <div className='row'>
        <div className='gamePresntation col-md-12 d-block text-center p-4 bg-secondary box rounded'>
          <h1 className='mb-3' style={{ color: "antiquewhite" }}>
            Hangman
          </h1>
          <h4 className='text-light'>Find the hidden rock band 🤘</h4>
        </div>
      </div>
      <div className='row mb-3'>
        <div
          className='col-md-12 col-lg-8 mt-3'
          style={{ backgroundColor: "white" }}>
          <div className='row'>
            <div className='hangedManContainer text-center d-block'>
              <div>
                <img
                  className='hangedImg'
                  src={imgHangman[wrongLetters.length]}
                  alt=''
                />
                {wrongLetters.length === 1 && (
                  <img style={{ position: "absolute" }} src={set1B} alt='' />
                )}
              </div>

              <div className='rightLetters'>
                {currentBand?.split("")?.map(letter => {
                  if (letter === " ")
                    return <span key={letter}>&nbsp;&nbsp;</span>;
                  if (rightLettersWritten.includes(letter)) return letter;
                  return " _ ";
                })}
              </div>
            </div>
          </div>
        </div>
        <div className='col-md-12 col-lg-4 text-center p-4 mt-3 grid-container2 rounded-end'>
          <div className=''>
            <h4 className='text-white'>Wrong Guesses</h4>
            <h5 className='text-light'>{wrongLetters.length} out of 6</h5>
          </div>
          <div>
            <h1 className='text-dark'>Wrong letters</h1>
          </div>
          <div className='grid-container3 rounded p-5'>
            {wrongLetters.map(letter => {
              return (
                <button
                  key={letter}
                  className={`btnFamily2 bg-danger rounded text-dark`}
                  disabled={wrongLetters.includes(letter)}>
                  {letter}
                </button>
              );
            })}
          </div>
        </div>
      </div>
      <div className='row mb-3'>
        <div className='keyBoard col-md-12 d-flex p-5 justify-content-center rounded'>
          <div className='grid-container p-2 rounded'>
            {keyBoard.map(letter => {
              return (
                <button
                  key={letter}
                  className={`btns-keyboards rounded text-white ${
                    rightLettersWritten.includes(letter) ? "btnCorrect" : " "
                  } ${wrongLetters.includes(letter) ? "btnIncorrect" : " "}`}
                  disabled={
                    wrongLetters.includes(letter) ||
                    rightLettersWritten.includes(letter)
                  }
                  onClick={() =>
                    handleClickLetter(letter, currentBand?.split(""))
                  }>
                  {letter}
                </button>
              );
            })}
            <button
              onClick={reStart}
              className='refreshBtn rounded text-white align-self-center justify-content-end'>
              <img className='refreshIcon' src={reIcon} alt='' />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default new Content({
  Component: Ahorcado,
  title: "Ahorcado",
  route: "Ahorcado"
});
